import { getPatientEventStatus } from './getPatientEventStatus.js';
import { isPatientVisibleEvent } from './isPatientVisibleEvent.js';
export function getPatientChatStateFold(prev, event) {
    const lastSeq = prev.lastSeq ?? prev.lastEvent?.seq;
    if (lastSeq != null && event.seq !== lastSeq + 1) {
        return null;
    }
    // ENDED is terminal — no further status transitions allowed
    if (prev.status === 'ENDED') {
        if (lastSeq !== event.seq) {
            return { status: prev.status, lastEvent: prev.lastEvent, lastSeq: event.seq };
        }
        return prev;
    }
    const status = getPatientEventStatus(event) ?? prev.status;
    const lastEvent = isPatientVisibleEvent(event) ? event : prev.lastEvent;
    // No status/snippet impact (incl. technical/invisible events) — bump lastSeq only
    if (status === prev.status && lastEvent === prev.lastEvent) {
        if (lastSeq !== event.seq) {
            return { status, lastEvent, lastSeq: event.seq };
        }
        return prev;
    }
    return { status, lastEvent, lastSeq: event.seq };
}
//# sourceMappingURL=getPatientChatStateFold.js.map